import { SVGProps, Ref, forwardRef } from 'react';

export const ImageStackOutlinedSize32Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={32} height={32} viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <path
                d="M27.407 4.222c-.564-1.08-1.555-1.772-3.074-2.206-1.892-.54-4.604-.683-8.333-.683s-6.441.142-8.334.683c-1.519.434-2.51 1.125-3.074 2.206 1.016-.392 2.123-.655 3.29-.839 2.237-.352 4.95-.45 8.118-.45s5.88.098 8.118.45c1.166.184 2.274.447 3.29.84"
                fill="currentColor"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M23.745 16.706c-.633.76-1.582 1.161-2.745 1.161s-2.113-.402-2.745-1.161c-.6-.72-.789-1.61-.789-2.372s.188-1.652.789-2.373c.633-.759 1.581-1.16 2.745-1.16 1.163 0 2.112.401 2.744 1.16.601.72.79 1.611.79 2.373 0 .761-.189 1.651-.79 2.372M21.9 15.17c.128-.155.232-.431.232-.836s-.104-.682-.232-.836c-.097-.116-.315-.298-.901-.298s-.805.182-.901.298c-.129.154-.233.43-.233.836s.104.681.233.836c.096.116.314.297.9.297s.805-.181.902-.297"
                fill="currentColor"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M1.61 18C.3 6.917 3.407 5.334 16 5.334S31.699 6.917 30.39 18 27.284 30.667 16 30.667 2.918 29.083 1.61 18m3.498-8.628c-1.076.876-1.779 2.726-1.115 8.347.204 1.726.413 3.153.654 4.344l6.803-4.861 6.822 4.692 4.558-3.14 4.529 3.28c.239-1.185.446-2.604.648-4.315.664-5.62-.039-7.471-1.115-8.347-.62-.505-1.664-.955-3.52-1.247-1.846-.29-4.244-.391-7.372-.391s-5.525.1-7.371.39c-1.857.293-2.902.743-3.521 1.248m21.585 15.142-3.898-2.822-4.522 3.116-6.796-4.675-6.162 4.402c.401 1.087.849 1.725 1.335 2.153.57.502 1.429.92 2.953 1.197 1.55.28 3.597.382 6.397.382s4.846-.101 6.397-.382c1.524-.276 2.383-.695 2.953-1.197.49-.43.94-1.074 1.343-2.174"
                fill="currentColor"
            />
        </g>
    </svg>
));
ImageStackOutlinedSize32Glyph.displayName = 'ImageStackOutlinedSize32Glyph';
